export const appIcon = {
  CARGO: 'mdi-ferry',
  FIRE: 'mdi-fire',
  MOTOR: 'mdi-car',
  PA: 'mdi-ambulance',
  TRAVEL: 'mdi-plane-shield',
  PACKAGE: 'mdi-animation',
  MAID: 'mdi-broom',
  CURR: 'mdi-currency-usd'
}

export const dri = {
  D: 'Direct',
  R: 'Reinsurance'
}

export const appID = {
  CARGO: 'CA',
  HEALTH: 'HE',
  HULL: 'HU',
  FIRE: 'FI',
  MOTOR: 'MO',
  PA: 'PA',
  TRAVEL: 'TR',
  PACKAGE: 'PK',
  MISC: 'MI',
  MAID: 'MD'
}

export const appIDDesc = {
  CA: 'Cargo',
  HE: 'Health',
  HU: 'Hull',
  FI: 'Fire',
  MO: 'Motor',
  PA: 'Personal Accident',
  TR: 'Travel',
  PK: 'Package',
  MI: 'Misc',
  MD: 'Maid',
  BD: 'Bond'
}

export const quoteStatus = {
  NQ: 'Quotation',
  QPA: 'Quotation Pending Approval',
  QA: 'Quotation Approved',
  QD: 'Quotation Declined',
  NP: 'Proposal',
  PPA: 'Proposal Pending Approval',
  PD: 'Proposal Declined',
  IF: 'In-Force',
  PO: 'Policy',
  VO: 'Void',
  NTU: 'Not Taken Up',
  CL: 'Cancellation',
  DC: 'Declined'
}

export const maritalStatus = {
  S: 'S - Single',
  M: 'M - Married',
  D: 'D - Divorced',
  W: 'W - Widowed',
  P: 'S - Separated'
}

export const gender = {
  M: 'M - Male',
  F: 'F - Female'
}

export const salutation = {
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MDM: 'Mdm',
  DR: 'Dr'
}

export const ccType = {
  AMEX: 'American Express',
  JCB: 'JCB',
  MAS: 'Master Card',
  VIS: 'Visa',
  OTH: 'Others'
}

export const applicantStatus = {
  I: 'Individual',
  E: 'Entity'
}

export const interTitle = {
  BLANK: 'Blank',
  THE: 'The',
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MDM: 'Mdm',
  SIR: 'Sir',
  DR: 'Dr'
}

export const interCommType = {
  O: 'Optional',
  M: 'Mandatory',
  N: 'Not Allowed',
  P: 'Protected'
}

export const interRegAgt = {
  R: 'Registered',
  N: 'Non-Registered'
}

export const interInsdDisc = {
  N: 'No',
  P: 'Protected',
  M: 'Mandatory',
  O: 'Optional'
}

// export const interRegCat = {
//   F: 'Foreign',
//   L: 'Local',
//   N: 'Not Applicable'
// }

// export const interCashCR = {
//   C: 'Cash',
//   R: 'Credit'
// }

export const interStmtType = {
  N: 'None',
  O: 'Open Item',
  B: 'Brought Forward'
}

export const interGrossNet = {
  G: 'Gross',
  N: 'Net'
}

export const insuredTitle = {
  BLANK: '',
  THE: 'The',
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MDM: 'Mdm',
  DR: 'Dr',
  DATUK: 'Datuk',
  DATIN: 'Datin',
  TUN: 'Tun'
}

export const insuredClientGrp = {
  I: 'Individual',
  C: 'Corporation'
}

export const insuredGender = {
  F: 'Female',
  M: 'Male',
  N: 'Not Applicable'
}

export const uomUN = {
  A: 'A - Not applicable',
  B: 'B - Blank',
  C: 'C - Covered',
  N: 'N - Not covered',
  U: 'U - Unlimited'
}

export const tranType = {
  N: 'N - New',
  R: 'R - Renewal'
}

export const custLogTypeView = {
  ALL: 'All',
  CL: 'Claims Only',
  UW: 'Underwriting Only'
}

export const custLogTypeOpt = {
  A: 'All',
  S: 'Selected'
}

export const cPolTypeOpt = {
  A: 'All',
  S: 'Selected'
}

export const cPropStat = {
  A: 'All',
  S: 'Selected'
}

export const propType = {
  FI: 'FI - Fire',
  MA: 'MA - Machinery'
}

export const srchBy = {
  S: 'S - Scheme',
  C: 'C - Class'
}

export const propType2 = {
  ALL: 'All Proposals',
  FI: 'Fire',
  MA: 'Machinery'
}

export const excludePremHdg = {
  'A': 'A – As Arrange',
  'D': 'D – Deposit',
  'F': 'F – Free Insurance',
  'M': 'M – Minimum',
  'P': 'P – Project',
  'R': 'R – Each Risk',
  '1': '1 – Takaful As Arrange',
  '2': '2 – Takaful Free Insurance',
  '3': '3 – Takaful'
}
